import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { Pagination } from 'antd';
import { ApkAssignmentContext, IApkAssignmentContext } from '../../../../apkAssignmentState/apkAssignmentContext';
import style from './PaginationComponent.module.scss';

const PaginationComponent: React.FC = () => {
	const { changeCurrentPage, apkForAssign, currentPage, countOfItems } =
		useContext<IApkAssignmentContext>(ApkAssignmentContext);

	const from = (currentPage - 1) * Number(countOfItems) + 1;
	const to = currentPage * Number(countOfItems);
	const total = apkForAssign.count;

	return (
		<div className={style.container} data-test="PaginationComponent">
			<Text
				className={style.counter}
				translationNameSpace="listing"
				translationKey="paginationLabel"
				translationOptions={{
					from,
					to: to < total ? to : total,
					total,
				}}
				size="xs"
			/>
			<Pagination
				current={currentPage}
				pageSize={Number(countOfItems)}
				total={apkForAssign.count}
				onChange={changeCurrentPage}
				showSizeChanger={false}
			/>
			<div className={style.plug} />
		</div>
	);
};

export default PaginationComponent;
